<template>

  <main class="main-content" id="topDom">
    <section class="section --banner">
      <ul class="breadcrumb">
        <li class="breadcrumb__li --current">
          <router-link to="/" class="breadcrumb__link">{{ $t("i18n.home") }}</router-link>
        </li>
        <li class="breadcrumb__li --current">
          <span class="breadcrumb__text"> {{ $t("i18n.headerMain.otherProducts") }}</span>
        </li>
        <li class="breadcrumb__li">
          <span class="breadcrumb__text"> {{ $t("i18n.headerMainChildren.MNE") }}</span>
        </li>
      </ul>
      <div class="banner">
        
        <div class="banner__content container-fluid">
          <div class="row align-items-center">
            <div class="col-12 col-md-6 order-2 order-md-1">
              <h1 class="banner__title">{{ $t("i18n.headerMainChildren.MNE") }}</h1>
              <p class="banner__text" v-html="$t('i18n.mneHeaderText')"></p>
            </div>
          </div>
        </div>
        <div class="banner__bg">
          <img :src="form.bgImg" />
        </div>
      </div>

      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="content-main">
              <div class="content-title">
                <h1 style="font-size: 3rem;font-weight: 500;">{{ $t("i18n.mneTitle") }}</h1>
              </div>
              <div class="content-text">
                <span v-html="$t('i18n.mneText')"></span>
              </div>
            </div>
          </div>
        </div>

        <div class="container">
          <div class="item --big">
            <div class="item-text">{{ $t('i18n.mneImgTextOne') }}</div>
            <img :src="form.imgOne" alt="FFKM,FKM - Orings">
          </div>
          <div class="item">
            <div class="item-text">{{ $t('i18n.mneImgTextTwo') }}</div>
            <img :src="form.imgTwo" alt="FFKM,FKM - Orings">
          </div>
          <div class="item">
            <div class="item-text">{{ $t('i18n.mneImgTextThree') }}</div>
            <img :src="form.imgThree" alt="FFKM,FKM - Orings">
          </div>
        </div>


        <div class="download-content">
          <div class="summary-table --mobile-full-width">
            <div class="summary-table__wrapper">
              <!-- <a target="_blank" class="download-link --small  --thumb ">
                <div class="download-link__content mr-2">
                  <h4 class="download-link__title">
                    {{ $t("i18n.mneDownloadTextOne") }}
                  </h4>
                </div>
                <div class="ml-auto" style="display: flex">
                  <span class="badge mr-0p5 mr-md-1" v-hover="{ className: '--upper' }">{{ form.type }}</span>
                  <span class="badge mr-0p5 mr-md-1" v-hover="{ className: '--upper' }">{{ form.size }}</span>
                  <span class="download-link__download"> {{ $t('i18n.download') }}</span>
                </div>
              </a>
              <a target="_blank" class="download-link --small  --thumb ">
                <div class="download-link__content mr-2">
                  <h4 class="download-link__title">
                    {{ $t("i18n.mneDownloadTextTwo") }}
                  </h4>
                </div>
                <div class="ml-auto" style="display: flex">
                  <span class="badge mr-0p5 mr-md-1" v-hover="{ className: '--upper' }">{{ form.type }}</span>
                  <span class="badge mr-0p5 mr-md-1" v-hover="{ className: '--upper' }">{{ form.size }}</span>
                  <span class="download-link__download"> {{ $t('i18n.download') }}</span>
                </div>
              </a> -->
              <a target="_blank" class="download-link --small  --thumb ">
                <div class="download-link__content mr-2">
                  <h4 class="download-link__title">
                    {{ $t("i18n.mneDownloadTextThree") }}
                  </h4>
                </div>
                <div class="ml-auto" style="display: flex">
                  <span class="badge mr-0p5 mr-md-1" v-hover="{ className: '--upper' }">{{ form.type }}</span>
                  <span class="badge mr-0p5 mr-md-1" v-hover="{ className: '--upper' }">{{ form.size }}</span>
                  <span class="download-link__download" @click="download"> {{ $t('i18n.download') }}</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>


      <div class="container-fluid">
        <div class="row">
          <div class="col-12 footer-btn">
            <button class="va-btn" @click="goPageHome">{{ $t('i18n.backHomePage') }}</button>
            <button class="va-btn ml-auto" @click="goPageNext" :class="{'set-display': !form.isLast}">{{ $t('i18n.next') }}</button>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import {downloadFile} from "../api/api";
export default {
  name: "mne",
  data() {
    return {
      form: {
        bgImg: this.isMobile() ? require("../assets/imgs/mfqBg.png") : require("../assets/imgs/mfqBg.png"),
        imgOne: require('../assets/imgs/mneMainImgOne.png'),
        imgTwo: require('../assets/imgs/mneMainImgTwo.png'),
        imgThree: require('../assets/imgs/mneMainImgThree.png'),
        type: "PDF",
        size: "10M",
        id:29
      }
    }
  },
  // created() {
  //   this.goTop();
  // },
  mounted () {
    this.goTop();
  },
  methods: {
    download() {
      if (!this.$store.state.isLogin) {
        this.$router.push("login");
      }
      downloadFile({ id: this.form.id }, localStorage.getItem('token')).then(res => {
        if (res.data && res.data.code == '1') {
          // window.open("http://a34.madpay.com/" + res.data.data)
          window.open("https://www.jiashengvac.com/" + res.data.data)
          // window.open("http://admin.jiashengvac.com/" + res.data.data)
        } else if (res.data && res.data.code == '0') {
          Message({
            message: "暂无下载文件",
            // message: error.message,
            type: 'error',
            duration: 3 * 1000
          });
        } else {
          Message({
            message: res.data.msg,
            // message: error.message,
            type: 'error',
            duration: 3 * 1000
          });
          if (res.data.msg === "请重新登录") {
            this.$router.push("login")
          }
        }
      })
    },
    isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    },
    goPageHome() {
      this.$router.push("/")
    },
    goPageNext() {
      this.$router.push("unisemChiller")
    },
    goTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' }); // 平滑滚动到顶部
      // document.querySelector('#topDom').scrollIntoView({
      //   behavior: 'smooth'
      // })
    },
  },
}
</script>



<style scoped>

img {
  max-width: 100%;
}
.breadcrumb {
  display: flex;
  height: 8rem;
  align-items: center;
  position: absolute;
  z-index: 80;
  left: 5rem;
  margin: 0;
  padding: 0;
}
.breadcrumb__li {
  position: relative;
  padding-right: 2.5rem;
  margin-right: 2rem;
}
.breadcrumb__link {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #FFFFFF;
  letter-spacing: 0;
  display: block;
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.breadcrumb__li.--current .breadcrumb__text{
  color: #e3e3e3;
}
.breadcrumb__li.--current:after {
  content: "";
  width: 0.6rem;
  height: 1rem;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -0.3rem;
  background: url(../assets/imgs/arrow-breadcrumb.svg) no-repeat 50%;
}
.breadcrumb__li:last-child {
  padding-right: 0;
  margin-right: 0;
}
.breadcrumb__text {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #FFFFFF;
  letter-spacing: 0;
  display: block;
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.banner {
  width: 100%;
  height: 61rem;
  align-items: center;
  display: flex;
  background-image: url(../assets/imgs/di-1.png);
  background-size: cover; /* 保证背景图片覆盖元素并且不变形 */
  background-position: center; /* 将背景图片居中显示 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  padding: 0 0 0 28rem;
}
.banner__bg {
  /* position: absolute;
  width: 100%;
  height: 61rem; */
}
.banner__bg {
  z-index: 1;
}
.banner__bg img {
  /* max-width: 100%; */

  display: block;
  width: 100%;
  /* height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: 50% 50%;
  object-position: 50% 50%; */
}

.banner__content {
  position: relative;
  z-index: 2;
}
.banner__title {
  font-weight: 500;
  font-size: 4rem;
  color: #FFFFFF;
  letter-spacing: -.084rem;
  line-height: 6rem;
}

.banner__text {
  margin-top: 3rem;
  font-size: 2.1rem;
  font-weight: 500;
  color: #fff;
  letter-spacing: -.022rem;
  line-height: 3.3rem;
  padding-right: 2rem;
  text-wrap: nowrap;
}
.summary-table {
  width: 100%;
  padding: 5rem;
}

.summary-table {
  width: 100%;
  padding: 5rem;
  border: 0.1rem solid #e6e6e6;
  border-radius: 0.4rem;
}
.download-link.--small {
  height: 6rem;
}
.download-link {
  display: flex;
  width: 100%;
  align-items: center;
  min-height: 8rem;
  padding: 1rem 2rem 1rem 0;
  position: relative;
  cursor: pointer;
  border-bottom: 0.1rem solid #ededed;
  transition: all .2s ease-in-out;
}

.download-content {
  margin-top: 3rem;
}

.download-link__content {
  display: flex;
  align-items: center;
}
.download-link__title {
  font-size: 1.6rem;
  font-weight: 500;
  color: #000;
  display: block;
  letter-spacing: -.018rem;
  line-height: 3rem;
  margin: 0;
}
.badge.--upper {
  text-transform: uppercase;
}
.badge {
  border: .1rem solid #e6e6e6;
  height: 3rem;
  display: flex;
  align-items: center;
  white-space: nowrap;
  font-weight: 500;
  font-size: 1.1rem;
  color: #4c4c4c;
  letter-spacing: .03rem;
  padding: 0 1.5rem;
  cursor: pointer;
  border-radius: 2rem;
}
.download-link__download {
  font-size: 1.6rem;
  font-weight: 500;
  color: #800080;
  letter-spacing: -.018rem;
  line-height: 3rem;
  padding-right: 2rem;
  position: relative;
}

.badge.--upper {
  text-transform: uppercase;
}

.footer-btn {
  display: flex;
  margin-bottom: 6rem;
  margin-top: 3rem;
}

.va-btn {
  height: 5rem;
  width: 12rem;
  border: 2px solid #ededed;
  border-radius: 10%;
  background-color: white;
  color: #800080;
  font-size: 16px;
  font-weight: 600;
}

.content-main {
  margin-top: 10rem;
  margin-bottom: 3rem;
}
.content-title {
  color: #800080;
}
.content-text {
  margin-top: 5rem;
  font-family: Alibaba;
  font-weight: 500;
  font-size: 1.6rem;
  color: #231815;
  line-height: 4rem;
}

.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.item {
  width: auto;
  margin: 1rem;
  padding: 1rem;
}

.item img {
  max-width: 100%;
  height: 40rem;
}

.item-text {
  font-weight: normal;
  font-size: 3rem;
  color: #FFFFFF;
  line-height: 4rem;
  background-color: #5A246B;
  width: 100%;
  text-align: center;
}
@media (max-width: 1023.9px) {
  .summary-table {
    padding: 3rem;
    overflow: auto;
    width: calc(100% + 3rem);
    margin-left: -1.5rem;
  }
  .summary-table.--mobile-full-width .summary-table__wrapper {
    min-width: 100%;
    max-width: 100%;
    padding-right: 0;
    margin: 0;
  }
  .download-link.--small {
    height: auto;
    padding: 2rem 1.5rem;
    flex-wrap: wrap;
    width: calc(100% + 3rem);
    margin-left: -1.5rem;
  }
  .download-link__thumb {
    width: 5rem;
    height: 5rem;
    min-width: 5rem;
  }
  .download-link__title {
    line-height: 2.6rem;
    margin-bottom: 1rem;
  }
  .va-btn {
    width: 14rem;
  }
}

@media (max-width: 768px) {
  .banner {
    padding: 0;
  }
  .banner__bg {
    padding-right: 10px;
  }
  .banner__title {
    font-size: 16px;
    font-weight: bold;
    line-height: 1;
  }
  .banner__text {
    padding-right: 0px;
    margin-top: 20px;
    width: 180px;
    font-size: 14px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    /* // 超出几行省略 */
    -webkit-line-clamp: 10;  
    overflow:hidden;    
  }
  .breadcrumb {
    left: 2rem;
  }
  .breadcrumb__link {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/mne.vue